import { styled } from "@mui/material";

/**
 * Primary use case for this component is to style a file input. This input is visually hidden (but still has dimensions and can accept clicks).
 */
export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
